export default "__VITE_PUBLIC_ASSET__612bf3ca__"